const Minus = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="11"
            height="2"
            viewBox="0 0 11 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <line y1="1" x2="11" y2="1" stroke="#1D1D1B" />
        </svg>
    )
}

export default Minus
